import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import useFlash from "go-alert/AlertMessage";
import Header from "go-app/components/Header";
import handleError from "go-app/services/errors";
import { useBrowserTabTitle } from "go-core/components/BrowserTab/useBrowserTabTitle";
import { LoadingContainer } from "go-core/components/Loading";
import { useWindowSize } from "go-core/components/useWindowSize";
import { apiOrganization } from "../../../../../../../../services/Api/Organization/apiOrganization";
import {
	CompanyApi,
	JpkExportBodyApi,
	JpkExportFileType,
} from "../../../../../../../../services/Api/Organization/types";
import { api } from "../../../../../../../../services/Api/api";
import JpkExportForm from "./components/JpkExportForm";
import { getJpkDateRangeDefaultValue } from "./utils";

const OrganizationSettingsJpkExportPage = () => {
	const { t } = useTranslation();
	const [companyDetails, setCompanyDetails] = useState<CompanyApi | undefined>();
	const [stockLoading, setStockLoading] = useState(true);
	const { addFlash } = useFlash();
	const form = useForm<JpkExportBodyApi>({
		criteriaMode: "all",
		defaultValues: {
			file_type: JpkExportFileType.JPK_MAG,
			date_range: getJpkDateRangeDefaultValue(),
		},
	});
	const { setValue } = form;
	const isMobile = useWindowSize().isMobile;
	const { handleChangeTabTitle } = useBrowserTabTitle();

	useEffect(() => {
		handleChangeTabTitle(t("modules.jpk_export.header.title"));
		fetchCompanyDetails();
		fetchDefaultStock();
	}, []);

	const fetchCompanyDetails = async () => {
		try {
			const params = { include: "all" };
			const res = await apiOrganization.getCompany(params);
			setCompanyDetails(res);
		} catch (err) {
			handleError.alert(err, addFlash);
		}
	};

	const fetchDefaultStock = async () => {
		const stocks = await api.organization().getStockSearchSelect("", {});
		if (stocks.length > 0) {
			const stock = stocks[0];
			setValue("stock_id", stock.id.toString());
			setValue("stock", { id: stock.id, label: stock.label });
		}
		setStockLoading(false);
	};

	if (!companyDetails || stockLoading) return <LoadingContainer />;

	return (
		<div className="content">
			<div className="content-preview">
				{!isMobile && <Header title={t("modules.jpk_export.header.title")} />}
				<JpkExportForm companyDetails={companyDetails} form={form} />
			</div>
		</div>
	);
};

export default OrganizationSettingsJpkExportPage;
